export const ANYTIME_PREFERENCE_VALUE = '__anytime__';
